<div class="disclaimer">
  <app-contentful-rich-text [document]="disclaimerItem?.disclaimer?.json"></app-contentful-rich-text>
</div>
